var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOscuro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 28,
    viewBox: "0 0 160 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2344 6.9834L24.1826 7.07227H24.2354V21.04H24.1719L12.1172 28L0.0625 21.04H0V7.07227H0.0517578L0 6.9834L12.0967 0L12.1172 0.0361328L12.1387 0L24.2344 6.9834ZM3.14844 8.80176V19.1855L12.1162 24.3643L21.0859 19.1855V8.80176L13.6924 4.53223V16.0459H10.5439V4.53125L3.14844 8.80176ZM17.875 8.05078V19.7559H17.8662L17.8838 19.7871L12.1172 23.1172L12.1123 23.1094L12.1084 23.1172L6.3418 19.7881L9.3916 17.9131L12.1113 19.4834L14.7441 17.9639V6.35938L17.875 8.05078Z",
    fill: "url(#paint0_linear_172_45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.32 21.1602C152.227 21.1602 151.24 20.9268 150.36 20.4602C149.493 19.9935 148.807 19.3268 148.3 18.4602C147.807 17.5935 147.56 16.5802 147.56 15.4202C147.56 14.2735 147.813 13.2668 148.32 12.4002C148.827 11.5202 149.52 10.8468 150.4 10.3802C151.28 9.91351 152.267 9.68018 153.36 9.68018C154.453 9.68018 155.44 9.91351 156.32 10.3802C157.2 10.8468 157.893 11.5202 158.4 12.4002C158.907 13.2668 159.16 14.2735 159.16 15.4202C159.16 16.5668 158.9 17.5802 158.38 18.4602C157.873 19.3268 157.173 19.9935 156.28 20.4602C155.4 20.9268 154.413 21.1602 153.32 21.1602ZM153.32 18.2002C153.973 18.2002 154.527 17.9602 154.98 17.4802C155.447 17.0002 155.68 16.3135 155.68 15.4202C155.68 14.5268 155.453 13.8402 155 13.3602C154.56 12.8802 154.013 12.6402 153.36 12.6402C152.693 12.6402 152.14 12.8802 151.7 13.3602C151.26 13.8268 151.04 14.5135 151.04 15.4202C151.04 16.3135 151.253 17.0002 151.68 17.4802C152.12 17.9602 152.667 18.2002 153.32 18.2002Z",
    fill: "url(#paint1_linear_172_45)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.564 9.71994C142.87 9.71994 143.91 10.1466 144.684 10.9999C145.47 11.8399 145.864 12.9999 145.864 14.4799V20.9999H142.464V14.9399C142.464 14.1933 142.27 13.6133 141.884 13.1999C141.497 12.7866 140.977 12.5799 140.324 12.5799C139.67 12.5799 139.15 12.7866 138.764 13.1999C138.377 13.6133 138.184 14.1933 138.184 14.9399V20.9999H134.764V9.83994H138.184V11.3199C138.53 10.8266 138.997 10.4399 139.584 10.1599C140.17 9.86661 140.83 9.71994 141.564 9.71994ZM136.744 8.89994C137.064 6.92661 137.984 5.93994 139.504 5.93994C139.797 5.93994 140.05 5.98661 140.264 6.07994C140.49 6.15994 140.764 6.28661 141.084 6.45994C141.324 6.59327 141.517 6.69327 141.664 6.75994C141.81 6.81328 141.964 6.83994 142.124 6.83994C142.617 6.83994 142.904 6.53994 142.984 5.93994H144.744C144.424 7.91327 143.504 8.89994 141.984 8.89994C141.69 8.89994 141.43 8.85994 141.204 8.77994C140.99 8.68661 140.724 8.55327 140.404 8.37994C140.164 8.24661 139.97 8.15327 139.824 8.09994C139.677 8.03327 139.524 7.99994 139.364 7.99994C138.87 7.99994 138.577 8.29994 138.484 8.89994H136.744Z",
    fill: "url(#paint2_linear_172_45)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.585 8.67998C129.985 8.67998 129.492 8.50665 129.105 8.15998C128.732 7.79998 128.545 7.35998 128.545 6.83998C128.545 6.30665 128.732 5.86665 129.105 5.51998C129.492 5.15998 129.985 4.97998 130.585 4.97998C131.172 4.97998 131.652 5.15998 132.025 5.51998C132.412 5.86665 132.605 6.30665 132.605 6.83998C132.605 7.35998 132.412 7.79998 132.025 8.15998C131.652 8.50665 131.172 8.67998 130.585 8.67998ZM132.285 9.83998V21H128.865V9.83998H132.285Z",
    fill: "url(#paint3_linear_172_45)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.258 12.6798H125.418V20.9998H121.998V12.6798H120.758V9.83982H121.998V9.51982C121.998 8.14649 122.391 7.10649 123.178 6.39982C123.964 5.67982 125.118 5.31982 126.638 5.31982C126.891 5.31982 127.078 5.32649 127.198 5.33982V8.23982C126.544 8.19982 126.084 8.29316 125.818 8.51982C125.551 8.74649 125.418 9.15316 125.418 9.73982V9.83982H127.258V12.6798Z",
    fill: "url(#paint4_linear_172_45)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.202 9.83984V20.9998H115.782V19.4798C115.435 19.9732 114.962 20.3732 114.362 20.6798C113.775 20.9732 113.122 21.1198 112.402 21.1198C111.548 21.1198 110.795 20.9332 110.142 20.5598C109.488 20.1732 108.982 19.6198 108.622 18.8998C108.262 18.1798 108.082 17.3332 108.082 16.3598V9.83984H111.482V15.8998C111.482 16.6465 111.675 17.2265 112.062 17.6398C112.448 18.0532 112.968 18.2598 113.622 18.2598C114.288 18.2598 114.815 18.0532 115.202 17.6398C115.588 17.2265 115.782 16.6465 115.782 15.8998V9.83984H119.202Z",
    fill: "url(#paint5_linear_172_45)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.465 6.95996V9.69996H102.745V21H99.325V9.69996H95.605V6.95996H106.465Z",
    fill: "url(#paint6_linear_172_45)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1951 9.72021C86.5817 9.72021 87.6817 10.1402 88.4951 10.9802C89.3217 11.8202 89.7351 12.9869 89.7351 14.4802V21.0002H86.3351V14.9402C86.3351 14.2202 86.1417 13.6669 85.7551 13.2802C85.3817 12.8802 84.8617 12.6802 84.1951 12.6802C83.5284 12.6802 83.0017 12.8802 82.6151 13.2802C82.2417 13.6669 82.0551 14.2202 82.0551 14.9402V21.0002H78.6551V14.9402C78.6551 14.2202 78.4617 13.6669 78.0751 13.2802C77.7017 12.8802 77.1817 12.6802 76.5151 12.6802C75.8484 12.6802 75.3217 12.8802 74.9351 13.2802C74.5617 13.6669 74.3751 14.2202 74.3751 14.9402V21.0002H70.9551V9.84021H74.3751V11.2402C74.7217 10.7735 75.1751 10.4069 75.7351 10.1402C76.2951 9.86021 76.9284 9.72021 77.6351 9.72021C78.4751 9.72021 79.2217 9.90021 79.8751 10.2602C80.5417 10.6202 81.0617 11.1335 81.4351 11.8002C81.8217 11.1869 82.3484 10.6869 83.0151 10.3002C83.6817 9.91355 84.4084 9.72021 85.1951 9.72021Z",
    fill: "url(#paint7_linear_172_45)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7007 15.4002C56.7007 14.2535 56.914 13.2468 57.3407 12.3802C57.7807 11.5135 58.374 10.8468 59.1207 10.3802C59.8674 9.91351 60.7007 9.68018 61.6207 9.68018C62.4074 9.68018 63.094 9.84018 63.6807 10.1602C64.2807 10.4802 64.7407 10.9002 65.0607 11.4202V9.84018H68.4807V21.0002H65.0607V19.4202C64.7274 19.9402 64.2607 20.3602 63.6607 20.6802C63.074 21.0002 62.3874 21.1602 61.6007 21.1602C60.694 21.1602 59.8674 20.9268 59.1207 20.4602C58.374 19.9802 57.7807 19.3068 57.3407 18.4402C56.914 17.5602 56.7007 16.5468 56.7007 15.4002ZM65.0607 15.4202C65.0607 14.5668 64.8207 13.8935 64.3407 13.4002C63.874 12.9068 63.3007 12.6602 62.6207 12.6602C61.9407 12.6602 61.3607 12.9068 60.8807 13.4002C60.414 13.8802 60.1807 14.5468 60.1807 15.4002C60.1807 16.2535 60.414 16.9335 60.8807 17.4402C61.3607 17.9335 61.9407 18.1802 62.6207 18.1802C63.3007 18.1802 63.874 17.9335 64.3407 17.4402C64.8207 16.9468 65.0607 16.2735 65.0607 15.4202Z",
    fill: "url(#paint8_linear_172_45)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5765 15.2402C55.5765 15.5602 55.5565 15.8935 55.5165 16.2402H47.7765C47.8298 16.9335 48.0498 17.4668 48.4365 17.8402C48.8365 18.2002 49.3231 18.3802 49.8965 18.3802C50.7498 18.3802 51.3431 18.0202 51.6765 17.3002H55.3165C55.1298 18.0335 54.7898 18.6935 54.2965 19.2802C53.8165 19.8668 53.2098 20.3268 52.4765 20.6602C51.7431 20.9935 50.9231 21.1602 50.0165 21.1602C48.9231 21.1602 47.9498 20.9268 47.0965 20.4602C46.2431 19.9935 45.5765 19.3268 45.0965 18.4602C44.6165 17.5935 44.3765 16.5802 44.3765 15.4202C44.3765 14.2602 44.6098 13.2468 45.0765 12.3802C45.5565 11.5135 46.2231 10.8468 47.0765 10.3802C47.9298 9.91351 48.9098 9.68018 50.0165 9.68018C51.0965 9.68018 52.0565 9.90684 52.8965 10.3602C53.7365 10.8135 54.3898 11.4602 54.8565 12.3002C55.3365 13.1402 55.5765 14.1202 55.5765 15.2402ZM52.0765 14.3402C52.0765 13.7535 51.8765 13.2868 51.4765 12.9402C51.0765 12.5935 50.5765 12.4202 49.9765 12.4202C49.4031 12.4202 48.9165 12.5868 48.5165 12.9202C48.1298 13.2535 47.8898 13.7268 47.7965 14.3402H52.0765Z",
    fill: "url(#paint9_linear_172_45)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.34 6.95996V9.69996H39.62V21H36.2V9.69996H32.48V6.95996H43.34Z",
    fill: "url(#paint10_linear_172_45)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172_45",
    x1: 12.1177,
    y1: 2.01955,
    x2: 12.1177,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_172_45",
    x1: 32,
    y1: 14,
    x2: 178,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_172_45",
    x1: 32,
    y1: 14,
    x2: 178,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_172_45",
    x1: 32,
    y1: 14,
    x2: 178,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_172_45",
    x1: 32,
    y1: 14,
    x2: 178,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_172_45",
    x1: 32,
    y1: 14,
    x2: 178,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_172_45",
    x1: 32,
    y1: 14,
    x2: 178,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_172_45",
    x1: 32,
    y1: 14,
    x2: 178,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_172_45",
    x1: 32,
    y1: 14,
    x2: 178,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_172_45",
    x1: 32,
    y1: 14,
    x2: 178,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_172_45",
    x1: 32,
    y1: 14,
    x2: 178,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8531FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908654,
    stopColor: "#7CF0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOscuro);
export default __webpack_public_path__ + "static/media/logo_oscuro.fcc5bb23df20142063bc6faa4fe765fc.svg";
export { ForwardRef as ReactComponent };